<div class="flex flex-col h-full bg-white overflow-hidden">
  <!-- Contenu principal -->
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col items-center justify-center gap-10">
      <!-- Question -->
      <p class="fg-gris-1 text-[16px] font-medium text-center">
        {{ 'choose_order_type.question' | translate }}
      </p>

      <!-- Cartes de choix -->
      <div class="flex items-center gap-5">
        <!-- Formule -->
        <div
          class="bg-white rounded-[5px] w-[328px] h-[287px] flex flex-col items-center justify-between py-8 px-6"
        >
          <div
            class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0"
          >
            <img src="assets/images/icones/meal-plan.png" alt="" class="size-[50px] object-cover" />
          </div>

          <div class="flex flex-col items-center gap-2">
            <span class="fg-noir-2 text-[20px] font-semibold text-center">
              {{ 'choose_order_type.meal_plan.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] text-center leading-[21px] m-0">
              {{ 'choose_order_type.meal_plan.description' | translate }}
            </p>
          </div>

          <button
            type="button"
            (click)="selectMode('meal_plan')"
            class="bg-vert-1 border border-gris-4 rounded-[5px] h-[58px] w-full flex items-center justify-center text-white text-[16px] font-semibold cursor-pointer hover:brightness-95 transition-all"
          >
            {{ 'common.select' | translate }}
          </button>
        </div>

        <!-- Au plat -->
        <div
          class="bg-white rounded-[5px] w-[328px] h-[287px] flex flex-col items-center justify-between py-8 px-6"
        >
          <div
            class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0"
          >
            <img src="assets/images/icones/course.png" alt="" class="size-[50px] object-cover" />
          </div>

          <div class="flex flex-col items-center gap-2">
            <span class="fg-noir-2 text-[20px] font-semibold text-center">
              {{ 'choose_order_type.by_course.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] text-center leading-[21px] m-0">
              {{ 'choose_order_type.by_course.description' | translate }}
            </p>
          </div>

          <button
            type="button"
            (click)="selectMode('by_course')"
            class="bg-vert-1 border border-gris-4 rounded-[5px] h-[58px] w-full flex items-center justify-center text-white text-[16px] font-semibold cursor-pointer hover:brightness-95 transition-all"
          >
            {{ 'common.select' | translate }}
          </button>
        </div>
      </div>
    </div>
  </main>
</div>
